import {Component, Input, OnInit, ViewChild, ViewEncapsulation, NgZone} from '@angular/core';
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {HeaderCellInfoEventArgs, QueryCellInfoEventArgs, SortSettingsModel} from "@syncfusion/ej2-angular-grids";
import {FilterSettingsModel} from "@syncfusion/ej2-grids/src/grid/base/grid-model";
import {GridComponent} from "@syncfusion/ej2-angular-grids/src/grid/grid.component";

@Component({
  selector: 'sb-server-script-messages',
  templateUrl: './server-script-messages.component.html',
  styleUrls: ['./server-script-messages.component.scss'],
  encapsulation: ViewEncapsulation.None, // Needed to allow us to override global boostrap4 styles with !important
})
export class ServerScriptMessagesComponent implements OnInit {

  // Return a thunk that sets the dataSource
  @Input()
  get setLogEntries() {
    const self = this;
    return (data: any[]) => {
      self.zone.run(() => {
        self.listGrid.dataSource = self.dataSource = data.map((e) => {
          return {
            Message: e.message,
            Level: e.level,
            Name: e.name,
            Date: e.date
          };
        });
      });
    };
  }

  columns: ColumnModel[] = [
    {
      field: "Message",
      type: "string",
      width: "auto",
      allowFiltering: true
    },
    {
      field: "Name",
      type: "string",
      width: "200px",
      allowFiltering: false
    },
    {
      field: "Date",
      type: "string",
      width: "160px",
      allowFiltering: false,
    },
    {
      field: "LevelIcon",
      type: "string",
      width: "20px",
      allowFiltering: false
    },
    {
      field: "Level",
      type: "string",
      width: "100px",
      allowFiltering: false
    }
  ];

  sortSettings: SortSettingsModel = {
    columns: [
      {
        field: "Date",
        direction: "Ascending"
      }
    ]
  };

  filterSettings: FilterSettingsModel = {
    type: 'FilterBar',
    mode: 'Immediate',
    showFilterBarStatus: false,
    ignoreAccent: true,
    immediateModeDelay: 500,
    enableCaseSensitivity: false,
  };

  dataSource = [];

  @ViewChild("listGrid")
  listGrid: GridComponent;

  constructor(public zone: NgZone){ }

  ngOnInit(): void {
  }

  dataBound(e: any) {
    Object.assign((this.listGrid.filterModule as any).filterOperators, { startsWith: 'contains' });
  }

  queryCellInfo(args: QueryCellInfoEventArgs) {
    const level = args.data["Level"];
    if (args.column.field === 'Message') {
      const clazz = "text-" + level;
      (args.cell as HTMLElement).classList.add(clazz);
    } else if (args.column.field === 'LevelIcon') {
      let clazz = "";
      switch (level) {
        case ("INFO"):
          clazz = "icon-info-sign";
          break;
        case ("WARN"):
          clazz = "icon-warning-sign";
          break;
        case ("ERROR"):
          clazz = "icon-thumbs-down";
          break;
        default:
          clazz = "";
      }
      if (clazz) {
        (args.cell as HTMLElement).classList.add(clazz);
      }
    }
  }

  headerCellInfo(args: HeaderCellInfoEventArgs) {
    // TODO: hide column header
    // if (args.cell.column.field === "LevelIcon") {
    //   (args.node as HTMLElement).style.display = "none";
    // }
  }
}
